import { Category } from '@browsing/filters';

export function getSelectedCategories(categoryId: number, category: Category): Category {
    if (category.id === categoryId) {
        return category;
    }

    for (const c of category.categories || []) {
        const categ = getSelectedCategories(categoryId, c);
        if (categ) {
            return categ;
        }
    }

    return null;
}

export function getTrackingCategoryFilterValues(
    parentId: number,
    allCategories: Category,
    filterValues: number[],
): number[] {
    const category = getSelectedCategories(parentId, allCategories);
    if (!category || category.parentId < 0) {
        return filterValues;
    }

    return getTrackingCategoryFilterValues(category.parentId, allCategories, [
        category.id,
        ...filterValues,
    ]);
}
